import { useEffect } from "react";
import { useQueryString } from "~/hooks/use-query-string";
import type { G_GetVideoQuery } from "~/lib/graphql";
import { sendTrackingViewItem } from "~/lib/tracking/events";

type UseDetailProductViewItemArgs = {
  isVideoLoading: boolean;
  videoData: G_GetVideoQuery["video"] | undefined;
};

/**
 * 作品詳細ページを表示する時に発火するトラッキング関数
 * @see https://git.dmm.com/pages/dre/i3-ga-model/#tag/GA4/operation/post_view_item
 */
export const useDetailProductViewItem = (args: UseDetailProductViewItemArgs) => {
  const { isVideoLoading, videoData } = args;

  const { season } = useQueryString();

  useEffect(() => {
    if (isVideoLoading || !videoData) return;

    const trackingData = {
      id: season,
      name: videoData.titleName,
    };

    sendTrackingViewItem(trackingData);
  }, [isVideoLoading, videoData?.titleName]);
};
